'use strict'
import Vue from 'vue'
import Router from 'vue-router'
import { getAccessToken } from '@/utils/userInfo'
import { isStudy } from '@/utils/goStudy.js'
import i18n from '@/i18n'
import store from '@/store'
// import {
//   clearLoginInfo
// } from '@/utils'
import request from '@/utils/request'
import personCenter from '@/views/modules/personalCenter/route-my'
import orderCenter from '@/views/modules/order/route-order'
import goodCenter from '@/views/modules/good/good-route'
import goodRoute from '@/views/modules/activity/route-activity'
import demandRoute from '@/views/modules/demandManage/demand-route'
import spareRoute from '@/views/modules/storeSpare/route-spare'
import demoRoute from '@/views/modules/demo/route-demo'
import sceneRoute from '@/views/modules/scene/route'
import ecologyRoute from '@/views/modules/ecology/route'
import { punchoutLogin, punchoutMain, punchoutOtherLogin } from '@/views/modules/punchout/punchout-route'
import selectionInquiry from '@/views/modules/selectionInquiry/route-inquiry'
import AIRoute from '@/views/modules/AI/AI-route'
import specialActivityRoutes from '@/views/modules/specialActivity/route'
import corpWebsiteRoutes from '@/views/modules/corpWebsite/route'
import { getEnvConfig } from '@/utils/envConfig.js'
import { Base64 } from 'js-base64'
import Cookies from 'js-cookie'

// import {
//   // isURL
// } from '@/utils/validate'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}
Router.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(Router)

// 页面路由(独立页面)
export const pageRoutes = [{
  path: '/404',
  component: () => import('@/views/pages/404'),
  name: '404',
  meta: {
    title: '404未找到'
  },
  beforeEnter (to, from, next) {
    // 拦截处理特殊业务场景
    // 如果, 重定向路由包含__双下划线, 为临时添加路由
    if (/__.*/.test(to.redirectedFrom)) {
      return next(to.redirectedFrom.replace(/__.*/, ''))
    }
    next()
  }
},
{
  path: '/orderContract',
  component: () => import('@/views/modules/order/contract'),
  name: '/orderContract',
  meta: {
    title: '查看合同',
    needToken: true
  }
},
// {
//   path: '/login',
//   component: () => import('@/views/pages/login'),
//   name: 'login',
//   meta: {
//     title: i18n.t('header.login')
//   }
// },
// 20250410 登录注册优化
{
  path: '/login',
  component: () => import('@/views/pages/login/index'),
  name: 'login',
  meta: {
    title: i18n.t('header.login')
  }
},
// {
//   path: '/forget',
//   component: () => import('@/views/pages/forgetpassword'),
//   name: 'forget',
//   meta: {
//     title: i18n.t('forget.title2')
//   }
// },
{
  path: '/forget',
  component: () => import('@/views/pages/login/forget'),
  name: 'forget',
  meta: {
    title: i18n.t('forget.title2')
  }
},
{
  path: '/ecologicalServices-join',
  name: 'ecologicalServices-join',
  component: () => import('@/views/modules/ecology/join'),
  meta: { title: '加入中控技术工程生态资源库', needToken: false }
},
// {
//   path: '/login-register',
//   component: () => import('@/views/pages/loginRegister'),
//   name: 'login-registe',
//   meta: {
//     title: i18n.t('login.register')
//   }
// },
{
  path: '/login-register',
  component: () => import('@/views/pages/login/register'),
  name: 'login-registe',
  meta: {
    title: i18n.t('login.register')
  }
},
{
  path: '/register',
  component: () => import('@/views/pages/register'),
  name: 'register',
  meta: {
    title: i18n.t('login.register')
  }
},
{
  path: '/wxLoginPage',
  component: () => import('@/views/pages/wxLoginPage'),
  name: 'wxLoginPage',
  meta: {
    title: i18n.t('login.wxLogin')
  }
},
{
  path: '/wxReg',
  component: () => import('@/views/pages/wxReg'),
  name: 'wxReg',
  meta: {
    title: i18n.t('login.wxLogin')
  }
},
{
  path: '/authorization',
  component: () => import('@/views/pages/authorization'),
  name: 'authorization',
  meta: {
    title: i18n.t('login.authorization')
  }
},
{
  path: '/invitation-person',
  component: () => import('@/views/pages/invitation-person'),
  name: 'invitationPerson',
  meta: {
    title: '邀请个人'
  }
},
{
  path: '/applyUsed',
  component: () => import('@/views/modules/saas/applyUsed'),
  name: 'applyUsed',
  meta: {
    title: '申请试用'
  }
},
{
  path: '/consult',
  component: () => import('@/views/consult.vue'),
  name: 'consult',
  meta: {
    title: '在线咨询'
  }
},
{
  path: '/soc',
  component: () => import('@/views/modules/soc/securityConsole'),
  name: 'soc',
  meta: {
    title: 'soc安全控制台'
  }
},
{
  path: '/Ethernet-APL',
  component: () => import('@/views/pages/Ethernet-APL/index'),
  name: 'Ethernet-APL',
  meta: {
    title: 'Ethernet-APL生态领航计划',
    needToken: false
  }
},
{
  path: '/',
  redirect: {
    name: 'main'
  }
},
{
  path: '/brainLogin',
  component: () => import('@/views/pages/brainLogin'),
  name: 'brainLogin',
  meta: {
    title: '跳转'
  }
},
{ // supcon专区
  path: '/supcon',
  component: () => import('@/views/modules/supcon/index'),
  name: 'supcon',
  meta: {
    title: 'SUPCON专区',
    needToken: false
  }
},
{ // 单点登录页
  path: '/signOn',
  component: () => import('@/views/pages/signOn'),
  name: 'signOn',
  meta: {
    title: 'signOn',
    needToken: false
  }
},
{
  path: '/feedback',
  component: () => import('@/views/modules/feedback/index'),
  name: 'feedback',
  meta: {
    title: '诉求反馈'
  }
},
punchoutLogin, // punchout单点登录页
punchoutMain, // punchout功能路由
punchoutOtherLogin // 模拟登陆页面
]

// 模块路由(基于主入口布局页面)
export const moduleRoutes = {
  path: '/',
  component: () => import('@/views/main/index.vue'),
  name: 'main',
  // redirect: {
  //   name: 'home'
  // },
  //  //PLANTMATE_工业一站式服务平台中控电子商务平台官方网站
  meta: {
    title: i18n.t('route.home')
  },
  children: [{
    path: '/home',
    component: () => import('@/views/modules/home/index.vue'),
    name: 'home',
    redirect: {
      name: 'main'
    },
    meta: {
      title: '',
      isTab: true
    }
  },
  {
    path: '/knowledge',
    component: () => import('@/views/modules/knowledge/knowledgeCommunity'),
    name: 'knowledge',
    meta: {
      title: '知识社区',
      isTab: true
    }
  },

  // 互动社区
  // ==================================== //
  // {
  //   path: '/community',
  //   component: () => import('@/views/modules/community/community.vue'),
  //   name: 'community',
  //   meta: { title: '互动社区' },
  // redirect: { name: 'ExpertsQuestion' },
  // children: [
  //   { path: '/ExpertsQuestion', component: () => import('@/views/modules/community/ExpertsQuestion'), name: 'ExpertsQuestion', meta: { title: '专家问答' } },
  //   { path: '/PostBar', component: () => import('@/views/modules/community/PostBar'), name: 'PostBar', meta: { title: '贴吧' } }
  // ]
  // },
  // ==================================== //
  // { path: '/knowledgeDocList', component: () => import('@/views/modules/knowledge/knowledgeDocList'), name: 'knowledgeDocList', meta: { title: '技术文档列表' } },
  // { path: '/knowledgeDocDetail', component: () => import('@/views/modules/knowledge/knowledgeDocDetail'), name: 'knowledgeDocDetil', meta: { title: '技术文档详情' } },
  // { path: '/knowledgeVideoList', component: () => import('@/views/modules/knowledge/knowledgeVideoList'), name: 'knowledgeVideoList', meta: { title: '技术视频列表' } },
  // { path: '/knowledgeVideoDetail', component: () => import('@/views/modules/knowledge/knowledgeVideoDetail'), name: 'knowledgevideoDetil', meta: { title: '技术视频详情' } },
  {
    path: '/knowledgeSearchPage',
    component: () => import('@/views/modules/knowledge/knowledgeSearchPage'),
    name: 'knowledgeSearchPage',
    meta: {
      title: '知识社区搜索'
    }
  },
  {
    path: '/expertIndex',
    component: () => import('@/views/modules/expertfield/index'),
    name: 'expertIndex',
    meta: {
      title: '专家问答'
    },
    redirect: {
      name: 'askExpertIndex'
    },
    children: [{
      path: '/askExpertIndex',
      component: () => import('@/views/modules/expertfield/askExpertIndex'),
      name: 'askExpertIndex',
      meta: {
        title: '专家首页'
      }
    },
    {
      path: '/askToExpert',
      component: () => import('@/views/modules/expertfield/askToExpert'),
      name: 'askToExpert',
      meta: {
        title: '我要提问'
      }
    },
    {
      path: '/chooseExpert',
      component: () => import('@/views/modules/expertfield/chooseExpert'),
      name: 'chooseExpert',
      meta: {
        title: '选择专家'
      }
    },
    {
      path: '/categoryArticle',
      component: () => import('@/views/modules/expertfield/categoryArticle'),
      name: 'categoryArticle',
      meta: {
        title: '问题分类'
      }
    },
    {
      path: '/exportDetail',
      component: () => import('@/views/modules/expertfield/exportDetail'),
      name: 'exportDetail',
      meta: {
        title: '专家详情'
      }
    },
    {
      path: '/postsDetail',
      component: () => import('@/views/modules/expertfield/postsDetail'),
      name: 'postsDetail',
      meta: {
        title: '问题详情'
      }
    }
    ]
  },
  {
    path: 'bestGoodsList',
    component: () => import('@/views/modules/good/bestGoodsList'),
    name: 'bestGoodsList',
    meta: {
      title: i18n.t('route.hotSaleList')
    }
  },
  // 被邀请页面
  {
    path: '/invited/:id',
    component: () => import('@/views/modules/invited'),
    name: 'invited',
    meta: {
      title: '首页',
      isTab: true
    }
  },
  // 软件下载
  {
    path: 'softWareDownload',
    component: () => import('@/views/modules/softWareDownload'),
    name: 'softWareDownload',
    meta: {
      title: '软件下载',
      isTab: true
    }
  },
  {
    path: 'planList',
    component: () => import('@/views/modules/plan/planListNew'),
    name: 'planList',
    meta: {
      title: '解决方案'
    }
  },
  {
    path: 'planContent',
    component: () => import('@/views/modules/plan/planContent'),
    name: 'planContent',
    meta: {
      title: '解决方案详情'
    }
  },
  {
    path: 'serviceList',
    component: () => import('@/views/modules/service/serviceListNew'),
    name: 'serviceList',
    meta: {
      title: '服务列表'
    }
  },
  {
    path: 'serviceContent',
    component: () => import('@/views/modules/service/serviceContent'),
    name: 'serviceContent',
    meta: {
      title: '专业服务详情'
    }
  },
  {
    path: 'onlineTraining',
    component: () => import('@/views/modules/trainManagement/index'),
    name: 'onlineTraining',
    meta: {
      title: '培训管理'
    }
  },
  // 贴吧
  {
    path: 'postBar',
    component: () => import('@/views/modules/trainManagement/postBar/postBarList'),
    name: 'postBarList',
    meta: {
      title: '贴吧问答列表'
    }
  },
  {
    path: 'questionInfo',
    component: () => import('@/views/modules/trainManagement/postBar/questionInfo'),
    name: 'questionInfo',
    meta: {
      title: '贴吧问题详情'
    }
  },
  {
    path: 'toAsk',
    component: () => import('@/views/modules/trainManagement/postBar/toAsk'),
    name: 'toAsk',
    meta: {
      title: '我要提问'
    }
  },
  // 互动社区
  {
    path: 'community',
    component: () => import('@/views/modules/trainManagement/community/community'),
    name: 'community',
    meta: {
      title: '互动社区'
    },
    redirect: {
      name: 'ExpertsQuestion'
    },
    children: [{
      path: '/community/ExpertsQuestion',
      component: () => import('@/views/modules/trainManagement/community/ExpertsQuestion'),
      name: 'ExpertsQuestion',
      meta: {
        title: '专家问答'
      }
    },
    {
      path: '/community/PostBar',
      component: () => import('@/views/modules/trainManagement/community/PostBar'),
      name: 'PostBar',
      meta: {
        title: '贴吧'
      }
    }
    ]
  },
  // 工业文库 (原书城)
  {
    path: 'trainbook',
    component: () => import('@/views/modules/trainManagement/book/bookList'),
    name: 'bookList',
    meta: {
      title: '工业文库'
    }
  },
  {
    path: 'trainbookInfo',
    component: () => import('@/views/modules/trainManagement/book/bookinfo'),
    name: 'bookinfo',
    meta: {
      title: '图书详情'
    }
  },
  {
    path: 'reviewbook',
    component: () => import('@/views/modules/trainManagement/book/reviewbook'),
    name: 'reviewbook',
    meta: {
      title: '图书预览'
    }
  },
  {
    path: 'trainbookDocList',
    component: () => import('@/views/modules/trainManagement/book/bookDocList'),
    name: 'bookDocList',
    meta: {
      title: '技术文档列表'
    }
  },
  {
    path: 'trainbookDocDetail',
    component: () => import('@/views/modules/trainManagement/book/bookDocDetail'),
    name: 'bookDocDetail',
    meta: {
      title: '技术文档详情'
    }
  },
  // { path: 'trainbook', component: () => import('@/views/modules/trainManagement/book/bookList'), name: 'bookList', meta: { title: '工业文库' } },
  // { path: 'trainbookInfo', component: () => import('@/views/modules/trainManagement/book/bookinfo'), name: 'bookinfo', meta: { title: '图书详情' } },
  // { path: 'reviewbook', component: () => import('@/views/modules/trainManagement/book/reviewbook'), name: 'reviewbook', meta: { title: '图书预览' } },
  // { path: '/knowledgeDocList', component: () => import('@/views/modules/knowledge/knowledgeDocList'), name: 'knowledgeDocList', meta: { title: '技术文档列表' } },
  // { path: '/knowledgeDocDetail', component: () => import('@/views/modules/trainManagement/trainTrend/knowledgeDocDetail'), name: 'knowledgeDocDetil', meta: { title: '技术文档详情' } },
  // 培训动态
  {
    path: 'trainTrend',
    component: () => import('@/views/modules/trainManagement/trainTrend/trainTrendList'),
    name: 'trainTrendList',
    meta: {
      title: '培训动态'
    }
  },
  {
    path: 'trainTrendInfo',
    component: () => import('@/views/modules/trainManagement/trainTrend/trainTrendInfo'),
    name: 'trainTrendInfo',
    meta: {
      title: '新闻详情'
    }
  },
  // 课程
  // 在线课堂
  {
    path: 'courseList',
    component: () => import('@/views/modules/trainManagement/course/courseList'),
    name: 'courseList',
    meta: {
      title: '课程列表'
    }
  },
  {
    path: 'courseDetail',
    component: () => import('@/views/modules/trainManagement/course/courseDetail'),
    name: 'courseDetail',
    meta: {
      title: '课程详情'
    }
  },
  {
    path: 'mobileCourseDetail',
    component: () => import('@/views/modules/trainManagement/mobile/mobileCourseDetail'),
    name: 'mobileCourseDetail',
    meta: {
      title: 'app手机课程详情'
    }
  },
  {
    path: '/knowledgeVideoList',
    component: () => import('@/views/modules/trainManagement/course/knowledgeVideoList'),
    name: 'knowledgeVideoList',
    meta: {
      title: '技术视频列表'
    }
  },
  {
    path: '/knowledgeVideoDetail',
    component: () => import('@/views/modules/trainManagement/course/knowledgeVideoDetail'),
    name: 'knowledgevideoDetil',
    meta: {
      title: '技术视频详情'
    }
  },
  {
    path: 'teacherList',
    component: () => import('@/views/modules/trainManagement/teacher/teacherList'),
    name: 'teacherList',
    meta: {
      title: '讲师列表'
    }
  },
  {
    path: 'teacherInfo',
    component: () => import('@/views/modules/trainManagement/teacher/teacherInfo'),
    name: 'teacherInfo',
    meta: {
      title: '讲师详情'
    }
  },
  // 资料下载
  {
    path: 'dataList',
    component: () => import('@/views/modules/trainManagement/dataList/dataList'),
    name: 'dataList',
    meta: {
      title: '资料列表'
    }
  },
  {
    path: 'dataDetail',
    component: () => import('@/views/modules/trainManagement/dataList/dataDetail'),
    name: 'dataDetail',
    meta: {
      title: '资料详情'
    }
  },
  // 证书查询
  {
    path: 'certificate',
    component: () => import('@/views/modules/trainManagement/certificate/certificateList'),
    name: 'certificateList',
    meta: {
      title: '证书查询'
    }
  },
  // 结算
  {
    path: 'settlement',
    component: () => import('@/views/modules/trainManagement/certificate/settlement'),
    name: 'settlement',
    meta: {
      title: '结算'
    }
  },
  // 直播培训
  {
    path: 'liveNotice',
    component: () => import('@/views/modules/trainManagement/livenotice/livenoticeList'),
    name: 'livenoticeList',
    meta: {
      title: '专题报告'
    }
  },
  {
    path: 'onLineSignUp',
    component: () => import('@/views/modules/trainManagement/livenotice/onLineSignUp'),
    name: 'onLineSignUp',
    meta: {
      title: '在线报名'
    }
  },
  // { path: '/studentLive', component: () => import('@/views/modules/trainManagement/livenotice/studentLive'), name: 'studentLive', meta: { title: '直播' } },
  {
    path: 'about',
    component: () => import('@/views/modules/about/about'),
    name: 'about',
    meta: {
      title: i18n.t('route.about')
    }
  },
  {
    path: 'contact',
    component: () => import('@/views/modules/about/contact'),
    name: 'contact',
    meta: {
      title: i18n.t('route.contact')
    }
  },
  {
    path: 'startExam',
    component: () => import('@/views/modules/trainManagement/exam/startExam'),
    name: 'startExam',
    meta: {
      title: '开始考试',
      needToken: true
    }
  },
  { // 生态合作
    path: 'ecologicalCooperation',
    component: () => import('@/views/modules/ecologicalCooperation/index'),
    name: 'ecologicalCooperation',
    meta: {
      title: '生态合作',
      needToken: false
    }
  },
  { // 申请授权
    path: 'ecologicalCooperationRequirements',
    component: () => import('@/views/modules/ecologicalCooperation/applicationRequirements'),
    name: 'ecologicalCooperationRequirements',
    meta: {
      title: '申请授权',
      needToken: true
    }
  },
  { // 申请授权-创建
    path: 'ecologicalCooperationAdd',
    component: () => import('@/views/modules/ecologicalCooperation/add'),
    name: 'ecologicalCooperationAdd',
    meta: {
      title: '申请授权',
      needToken: true
    }
  },
  { // 应用商店
    path: 'appstore',
    component: () => import('@/views/modules/appstore/index'),
    name: 'appstore',
    meta: {
      title: '应用商店',
      needToken: false
    }
  },
  // 运费政策
  {
    path: 'freightPolicy',
    component: () => import('@/views/pages/policy/freightPolicy/index'),
    name: 'freightPolicy',
    meta: {
      title: '运费政策',
      needToken: false
    }
  },
  // 售后政策
  {
    path: 'afterSalePolicy',
    component: () => import('@/views/pages/policy/afterSalePolicy/index'),
    name: 'afterSalePolicy',
    meta: {
      title: '售后政策',
      needToken: false
    }
  },
  // 商品中心
  ...goodCenter,
  // 个人中心
  ...personCenter,
  // 订单中心
  ...orderCenter,
  // 商品活动
  ...goodRoute,
  // 需求派单
  ...demandRoute,
  // 联储联备
  ...spareRoute,
  ...demoRoute,
  ...sceneRoute,
  // 选型询价
  ...selectionInquiry,
  // 生态服务
  ...ecologyRoute,
  // AI
  ...AIRoute,
  // 企业站
  ...corpWebsiteRoutes
  ]
}

// 精品商城入口
const premiumRoutes = {
  path: '/',
  component: () => import('@/views/main/premium.vue'),
  name: 'premium',
  meta: {
    title: '精品商城'
  },
  children: [
    { // 精品商城
      path: '/premium',
      component: () => import('@/views/modules/premium/index'),
      name: 'premiumHome',
      meta: {
        title: '精品商城',
        needToken: false
      }
    },
    {
      path: '/premiumGoodCategoryList',
      component: () => import('@/views/modules/good/premiumGoodCategoryList'),
      name: 'premiumGoodCategoryList',
      meta: { title: '精品商城-商品列表', needToken: false }
    }
  ]
}

const plcRoutes = {
  path: '/',
  component: () => import('@/views/main/plc.vue'),
  name: 'plc',
  meta: {
    title: '渠道商'
  },
  children: [
    { // 渠道商
      path: '/plc',
      component: () => import('@/views/modules/plc/index'),
      name: 'plcHome',
      meta: {
        title: '渠道商-商品库',
        needToken: true
      }
    },
    { // 购物车
      path: '/plcCart',
      component: () => import('@/views/modules/plc/cart'),
      name: 'plcCart',
      meta: {
        title: '渠道商-购物车',
        needToken: true
      }
    },
    {
      path: '/plcOrderAdd',
      component: () => import('@/views/modules/plc/orderAdd'),
      name: 'plcOrderAdd',
      meta: {
        title: '渠道商-确认订单',
        needToken: true
      }
    },
    {
      path: '/plcOrderList',
      component: () => import('@/views/modules/plc/orderList'),
      name: 'plcOrderList',
      meta: {
        title: '渠道商-订单列表',
        needToken: true
      }
    },
    {
      path: '/plcOrderDetail',
      component: () => import('@/views/modules/plc/orderDetail'),
      name: 'plcOrderDetail',
      meta: {
        title: '渠道商-订单详情',
        needToken: true
      }
    }
  ]
}

// 优选品类
const preferredBrandRoutes = [
  {
    path: '/preferredBrand',
    component: () => import('@/views/modules/preferredBrand/index'),
    meta: {
      title: '优选品类',
      needToken: false
    },
    children: [
      {
        path: '',
        component: () => import('@/views/modules/preferredBrand/list'),
        name: 'preferredBrand-list',
        meta: {
          title: '优选品类',
          needToken: false
        }
      },
      {
        path: 'info',
        component: () => import('@/views/modules/preferredBrand/info'),
        name: 'preferredBrand-info',
        meta: {
          title: '优选品类',
          needToken: false
        }
      }
    ]
  }
]

// 场景化采购
const shoppingScenePurchaseRoutes = [
  {
    path: '/shopping-scene-purchase',
    name: 'shopping-scene-purchase',
    component: () => import('@/views/modules/shopping-scene-purchase/index'),
    meta: {
      title: '场景化采购',
      needToken: false
    }
  }
]
// 内容资讯
const contentInfoRoutes = {
  path: '/',
  component: () => import('@/views/main/contentInfo.vue'),
  name: 'contentInfo',
  meta: {
    title: '内容资讯'
  },
  children: [
    {
      // 内容资讯
      path: '/contentInfo',
      component: () => import('@/views/modules/contentInfo/index'),
      name: 'contentInfoHome',
      meta: {
        title: '内容资讯',
        needToken: false
      }
    },
    {
      path: '/contentInfoList',
      component: () => import('@/views/modules/contentInfo/contentInfoList'),
      name: 'contentInfoList',
      meta: { title: '内容资讯', needToken: false }
    },
    {
      path: '/contentInfoDetail',
      component: () => import('@/views/modules/contentInfo/contentInfoDetail'),
      name: 'contentInfoDetail',
      meta: { title: '内容资讯-详情', needToken: false }
    }
  ]
}

export function addDynamicRoute (routeParams, router) {
  // 组装路由名称, 并判断是否已添加, 如是: 则直接跳转
  var routeName = routeParams.routeName
  var dynamicRoute = window.SITE_CONFIG['dynamicRoutes'].filter(item => item.name === routeName)[0]
  if (dynamicRoute) {
    return router.push({
      name: routeName,
      params: routeParams.params
    })
  }
  // 否则: 添加并全局变量保存, 再跳转
  dynamicRoute = {
    path: routeName,
    component: () => import(`@/views/modules/${routeParams.path}`),
    name: routeName,
    meta: {
      ...window.SITE_CONFIG['contentTabDefault'],
      menuId: routeParams.menuId,
      title: `${routeParams.title}`
    }
  }

  router.addRoutes([{
    ...moduleRoutes,
    ...premiumRoutes,
    ...plcRoutes,
    ...preferredBrandRoutes,
    ...shoppingScenePurchaseRoutes,
    ...contentInfoRoutes,
    ...specialActivityRoutes,
    name: `main-dynamic__${dynamicRoute.name}`,
    children: [dynamicRoute]
  }])
  window.SITE_CONFIG['dynamicRoutes'].push(dynamicRoute)
  router.push({
    name: dynamicRoute.name,
    params: routeParams.params
  })
}

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: pageRoutes
    .concat(moduleRoutes)
    .concat(premiumRoutes)
    .concat(plcRoutes)
    .concat(preferredBrandRoutes)
    .concat(shoppingScenePurchaseRoutes)
    .concat(contentInfoRoutes)
    .concat(specialActivityRoutes)
})

let head = document.getElementsByTagName('head') // 获取head标签
let meta1 = document.createElement('meta') // 创建meta标签
let meta2 = document.createElement('meta')
meta1.name = 'keywords' // 设置name
meta2.name = 'description'
router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) { // 匹配前往的路由不存在
    next('/404')
  } else if (
    to.query.loginFrom === 'hall' &&
    to.query.pin &&
    to.query.pwd &&
    (getAccessToken() === '' || getAccessToken() === undefined)
  ) {
    // 展厅明文账号密码登录
    const params = {
      username: to.query.pin,
      password: Base64.encode(to.query.pwd),
      grant_type: 'password',
      appCode: window.SITE_CONFIG.appCode,
      client_id: 'shopping',
      loginType: '0',
      env: getEnvConfig().env,
      domain: getEnvConfig().domain
    }
    await Vue.prototype.$http
      .post(`/auth/login?env=${params.env}&domain=${params.domain}`, params)
      .then(({ data: res }) => {
        if (res.code !== 0) {
          return false
        }
        // console.log(window.top !== window.self)
        if (window.top !== window.self) {
          localStorage.setItem('access_token_shop', res.data.access_token)
          localStorage.setItem('username_shop', res.data.username)
          location.reload()
          return
        }
        Cookies.set('access_token_shop', res.data.access_token)
        Cookies.set('username_shop', res.data.username)
        location.reload()
      })
      .catch(() => {
        next()
      })
  } else if (to.meta.needToken === true && (getAccessToken() === '' || getAccessToken() === undefined)) {
    // clearLoginInfo()
    sessionStorage.setItem('redirectUrl', to.fullPath)
    console.log('登录弹窗')
    setTimeout(() => {
      Vue.prototype.bus.$emit('showLoginDialog')
    }, 100)
    next(false)
    return
  } else if (to.meta.punchoutNeedToken === true && (getAccessToken() === '' || getAccessToken() === undefined)) {
    next({
      name: to.meta.punchoutfailedLogin
    })
  }

  document.title = to.meta.title || '设置默认内容'
  meta1.content = to.meta.title || '设置默认内容'
  meta2.content = to.meta.title || '设置默认内容'
  head[0].appendChild(meta1)
  head[0].appendChild(meta2)

  if (!window.SITE_CONFIG['dynamicMenuRoutesHasAdded']) {
    let url = (getAccessToken() === '' || getAccessToken() === undefined) ? '/help/user/sys/dict/selectAllDict' : '/help/user/sys/dict/selectAllDictAfterLogin'
    // 获取字典列表, 添加并全局变量保存
    request.get(url).then((res, total, code, data) => {
      if (code !== 0) {
        return
      }
      window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
      window.SITE_CONFIG['dictList'] = res
    }).catch(() => { })
  }
  // 添加动态(菜单)路由
  // 已添加或者当前路由为页面路由, 可直接访问
  // if (to.matched.length === 0) { // 匹配前往的路由不存在
  //   next('/404')
  // } else {
  // 知识培训相关页面整理统一跳转
  const isStudyPage = isStudy(to)
  if (isStudyPage) {
    next({
      name: 'main'
    })
  } else {
    const isCorpUser = !!store.state.user.corpUserInfo.customerId
    if (isCorpUser && !to.fullPath.includes('corpWebsite')) {
      console.log(to)
      if (to.fullPath.includes('myShopCart')) {
        next({
          name: 'corpWebsite-myShopCart'
        })
      } else if (to.fullPath.includes('browseHistory')) {
        next({
          name: 'corpWebsite-browseHistory'
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
  // }
})

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
// function fnCurrentRouteIsPageRoute (route, pageRoutes = []) {
//   var temp = []
//   for (var i = 0; i < pageRoutes.length; i++) {
//     if (route.path === pageRoutes[i].path) {
//       return true
//     }
//     if (pageRoutes[i].children && pageRoutes[i].children.length >= 1) {
//       temp = temp.concat(pageRoutes[i].children)
//     }
//   }
//   return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
// }

// /**
//  * 添加动态(菜单)路由
//  * @param {*} menuList 菜单列表
//  * @param {*} routes 递归创建的动态(菜单)路由
//  */
// function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
//   var temp = []
//   for (var i = 0; i < menuList.length; i++) {
//     if (menuList[i].children && menuList[i].children.length >= 1) {
//       temp = temp.concat(menuList[i].children)
//       continue
//     }
//     // 组装路由
//     var route = {
//       path: '',
//       component: null,
//       name: '',
//       meta: {
//         ...window.SITE_CONFIG['contentTabDefault'],
//         menuId: menuList[i].id,
//         title: menuList[i].name
//       }
//     }
//     // eslint-disable-next-line
//     let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
//     if (isURL(URL)) {
//       route['path'] = route['name'] = `i-${menuList[i].id}`
//       route['meta']['iframeURL'] = URL
//     } else {
//       URL = URL.replace(/^\//, '').replace(/_/g, '-')
//       route['path'] = route['name'] = URL.replace(/\//g, '-')
//       route['component'] = () => import(`@/views/modules/${URL}`)
//     }
//     routes.push(route)
//   }
//   if (temp.length >= 1) {
//     return fnAddDynamicMenuRoutes(temp, routes)
//   }
//   // 添加路由
//   router.addRoutes([{
//     ...moduleRoutes,
//     name: 'main-dynamic-menu',
//     children: routes
//   },
//   {
//     path: '*',
//     redirect: {
//       name: '404'
//     }
//   }
//   ])
//   window.SITE_CONFIG['dynamicMenuRoutes'] = routes
//   console.log(window.SITE_CONFIG['dynamicMenuRoutes'])
//   window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
// }

export default router
